<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: ESM Woocommerce to Hubspot Integration
      Author: Wibert Muza
    Agency URL: https://esminbound.com
========================================================================================== -->

<template>
  <div id="demo-basic-card">
    <div class="vx-row">
      <div
        class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base"
      >
        <vx-card>
          <div slot="no-body">
            <img
              :src="AppActiveUser.hubspotImage"
              alt="content-img"
              class="responsive card-img-top"
            />
          </div>
          <h5 class="mb-2">{{ AppActiveUser.hubspotConnectionTitle }}</h5>
          <p class="text-grey">Hubspot Portal ID: {{ AppActiveUser.cards.portal_id }}</p>
          <p class="text-grey">{{ AppActiveUser.cards.url }}</p>
          <div class="flex justify-between flex-wrap">
            <vs-button
              class="mt-4 mr-2"
              color="warning"
              type="border"
              v-if="!AppActiveUser.cards.active"
              v-on:click="hubspotConnection()"
              >Connect</vs-button
            >
            <vs-button
              class="mt-4"
              color="danger"
              type="border"
              v-if="AppActiveUser.cards.active"
              @click="updatecards()"
              >Disconnect</vs-button
            >
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['AppActiveUser'])
  },
  methods: {
    hubspotConnection: function() {
      var authwindow = window.open(
        this.AppActiveUser.hubspotConnection,
        "_blank",
        "location=yes,scrollbars=yes,status=yes"
      );
      let cThis = this;
      var timer = setInterval(function() {
        if (authwindow.closed) {
          cThis.$store.dispatch("updateUserData");
          clearInterval(timer);          
          location.reload();
        }
      }, 1000);
    },
    updatecards: function() {  
      this.$store.commit('UPDATE_HUBSPOT', false);
      let cThis = this;
      setTimeout(function() {  
        cThis.$store.dispatch('updateConnectionSendData', cThis.AppActiveUser.cards);  
      }, 200);     
    }
  }
};
</script>
